var render = function (_h,_vm) {var _c=_vm._c;return _c('i',{staticClass:"vsm-icon",class:_vm.$options.methods.mergeFunctionalRenderContextClasses(_vm.data, _vm.props.src)})}
var staticRenderFns = []

export { render, staticRenderFns }